export const namespace = 'log'
